module.exports = __webpack_public_path__ + "static/img/three.b06adce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/4/three.png
// module id = 6zYz
// module chunks = 1